import SideGroup from "../../SideGroup";

const RightSide = () => {
  return (
    <div className="flex-right">
      <SideGroup />
    </div>
  );
};

export default RightSide;
